import React from 'react'
import t from '~t'
import { Outlet } from 'react-router-dom'
import Screen from '~co/screen/basic'
import config from '~config'
import Logo from '~assets/brand/icon_raw.svg?component'

export default ()=>(
	<Screen className={'ui-account-page'} appSize='large'>
		<div className={'ui-account-content'}>
			<a href='https://save.ltdhunt.com' target='_blank' tabIndex='-1'>
				<Logo className={'ui-account-logo'} />
			</a>

			<Outlet />
		</div>

		<footer className={'ui-account-footer'}>
			&copy; {new Date().getFullYear()} Save
			<a href={config.links.help.index} target='_blank'>{t.s('support')}</a>
		</footer>
	</Screen>
)